import moment from 'moment';
import { IService } from '../types';

export const checkIfChosenServicePossibleAtTime = (
  time: Date | null,
  chosenService: IService | undefined,
  generalBookedTime: Date[]
) => {
  if (!chosenService || !time) return false;
  const serviceDuration = chosenService.duration;
  const serviceStartTime = moment(time);
  const serviceEndTime = moment(time).add(serviceDuration - 1, 'm');

  return generalBookedTime?.some((bookedTime) =>
    moment(bookedTime).isBetween(serviceStartTime, serviceEndTime, null, '[]')
  );
};
